<template>

    <GestionePratiche />
  
  </template>
  
  <script>
  import GestionePratiche from '../components/pratiche/gestione-pratiche/GestionePratiche.vue'
  
  export default {
    components: {
      GestionePratiche
  
    },
    data() {
      return {
  
      }
    },
  
    created(){
      
    },
  
    mounted(){
      this.$eventBus.emit('page-change', {
        target: this,
        currentRoute: this.$router.currentRoute.value
      })
    },
  
    methods: {
      
    },
  }
  </script>
  